<template>
  <div id="login" class="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
    <div v-if="movil_login == true">
      <div id="carouselMovil" class="carousel slide">
        <ol class="carousel-indicators">
          <li data-target="#carouselMovil" data-slide-to="0" class="active" style="background-color: #d75600"></li>
          <li data-target="#carouselMovil" data-slide-to="1" style="background-color: #d75600"></li>
          <li data-target="#carouselMovil" data-slide-to="2" style="background-color: #d75600"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="para_movil">
              <center>
                <br /><br /><br /><br /><br /><br /><br /><br />
                <img style="width: 45% !important" src="img/fondos/iper-logo-blanco.png" class="d-block w-100"
                  alt="..." />
                <br /><br /><br /><br /><br /><br />
              </center>
            </div>
            <div align="center" class="mt-4">
              <h2 style="color: #d75600">Bienvenido</h2>
            </div>
            <div align="center" class="">
              <h6 style="color: #d75600">Siguiente</h6>
            </div>
            <br />
            <p align="center" class="text-primary" data-target="#carouselMovil" data-slide-to="2">
              Omitir
            </p>
            <br />
          </div>
          <div class="carousel-item">
            <div class="para_movil1">
              <br /><br /><br /><br /><br /><br /><br /><br />
              <br /><br /><br /><br /><br /><br /><br />
            </div>
            <div align="center" class="mt-4">
              <h3 style="color: #d75600">MÓDULO DE</h3>
              <h5 style="color: #d75600; margin-top: -5px">ADMINISTRACIÓN</h5>
            </div>
            <div align="center">
              <br />
              <h6>
                Facilita al profesional establecer las <br />
                medidas de intervención de cada uno de los peligros
                identificados en la operacón
              </h6>
              <br />
              <h6 style="color: #d75600">Siguiente</h6>
            </div>
            <br /><br />
          </div>
          <div class="carousel-item">
            <div class="para_movil">
              <center>
                <br /><br /><br /><br /><br /><br /><br /><br /><br />
                <img style="width: 45% !important" src="img/fondos/iper-logo-blanco.png" class="d-block w-100"
                  alt="..." />
                <br /><br /><br /><br />
              </center>
            </div>
            <div align="center" class="mt-4">
              <form v-on:submit.prevent="iniciar_sesion">
                <input v-model="email" class="form-control form-control-sm boton_login input-login" type="email"
                  placeholder="Correo electrónico" />
                <input id="input_pass" v-model="contraseña" class="
                    form-control form-control-sm
                    boton_login
                    input-login
                    mt-2
                  " type="password" placeholder="Contraseña" />
                <i onmouseover="document.getElementById('input_pass').type='text';"
                  onmouseout="document.getElementById('input_pass').type='password';" style="color: #e8640c"
                  class="fas fa-eye"></i>
                <br />
                <button class="btn btn_modal" style="
                    color: #878787;
                    font-size: 2vh;
                    text-align: center !important;
                    width: 84%;
                  " type="submit">
                  Iniciar Sesión</button><br />

                <span class="navbar-text tamaño_letra">{{
                  $store.state.version
                }}</span><br />
              </form>
            </div>
            <br /><br />
          </div>
        </div>
      </div>
      <div id="mySidenavMovil" class="sidenav">
        <a data-toggle="modal" data-target="#query_matriz" id="aboutMovil"><i
            class="fas fa-file-excel float-right"></i></a>
      </div>
    </div>
    <div v-if="pc_login == true">
      <div class="row justify-content-center">
        <div class="col-md-4 border p-3" style="margin-top: 15%; background-color: #F2F2F2; border-radius: 15px; border: 2px solid #e8640c !important;">
          <center>
            <form v-on:submit.prevent="iniciar_sesion">
              <div>
                <img style="width: 45% !important" src="img/fondos/iper-logo-color.png" alt="logo" />
              </div>
              <div>
                <input v-model="email" class="form-control form-control-sm boton_login input-login" type="email"
                placeholder="Correo electrónico" /><br />
                <input id="input_pass_pc" v-model="contraseña" class="form-control form-control-sm boton_login input-login"
                  type="password" placeholder="Contraseña" />
                <i class="fas fa-eye" onmouseover="document.getElementById('input_pass_pc').type='text'"
                  onmouseout="document.getElementById('input_pass_pc').type='password'" style="color: #e8640c"></i>
              </div>
              <div>
                <button class="btn btn_modal" style="color: #878787; font-size: 2vh; text-align: center !important; width: 84%;" type="submit">
                  Iniciar Sesión
                </button>
              </div>
              <div>
                <span class="navbar-text tamaño_letra">
                  {{$store.state.version}}
                </span>
                <Traduccion />
              </div>
            </form>
          </center>
        </div>
        <div id="mySidenav" class="sidenav">
          <a data-toggle="modal" data-target="#query_matriz" id="about"><i class="fas fa-file-excel"></i> Consultar
            Matriz</a>
        </div>
      </div>
    </div>

    <!-- MODAL COPIAR URL -->
    <div class="modal fade" id="query_matriz" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" @click="activar_lector()" type="button"
                      data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                      Leer Código QR
                    </button>
                  </h2>
                </div>

                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body">
                    <center>
                      <div v-if="active == true">
                        <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>
                      </div>
                    </center>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                      data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      Consultar por enlace
                    </button>
                  </h2>
                </div>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                  <div class="card-body">
                    <div class="form-group">
                      <label>Pegue aquí la URL</label>
                      <input class="form-control rounded-pill" type="text" v-model="url_mariz" />
                    </div>
                    <button class="btn btn_modal" @click="consultarMatriz()">
                      Consultar Matriz
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// IMPORTACIÓN DE VUE
import Vue from "vue";
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
// IMPORTACIÓN DE QR
import VueQrcodeReader from "vue-qrcode-reader";
import Traduccion from "@/components/Traduccion/Traduccion.vue";
Vue.use(VueQrcodeReader);

export default {
  name: "login",

  components: {
    Traduccion
  },

  data() {
    return {
      email: "",
      contraseña: "",

      // VERSIÓN PARA DISPOSITIVOS MÓVILES - WINDOWS PHONE - IOS - ANDROID
      movil_login: false,
      pc_login: false,
      url_mariz: null,
      active: false,
    };
  },
  created() {
    this.versionCeluApto();
    this.pausar_corousel();
    this.$store.state.session_nombre = null;
    this.$store.state.session_apellido = null;

    this.$store.state.email = null;
    this.$store.state.email_session = null;

    // VARIABLES DEL NAVBAR
    this.$store.state.show_navbar = null;

    this.$store.state.user_auth = false;
    this.$store.state.global_esAdmin = false

    // VARIABLES MSP
    this.$store.state.global_privilegio_matriz_peligro = {
      crear: false,
      consultar: false,
      editar: false,
      eliminar: false,
      descargar_excel: false,
      copiar_matriz: false,
      verificacion_cyd: false,
    };
    this.$store.state.global_privilegio_admin_registro_cliente = {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    };
    this.$store.state.global_privilegio_admin_registro_proceso = {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    };
    this.$store.state.global_privilegio_admin_registro_peligro = {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    };
    this.$store.state.global_privilegio_admin_registro_efecto_posible = {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    };
    this.$store.state.global_privilegio_admin_registro_control_medida = {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    };
    this.$store.state.global_privilegio_admin_registro_usuario = {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    };
    this.$store.state.global_privilegio_admin_registro_regional = {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    };
    this.$store.state.global_privilegio_regional = [];
  },
  methods: {
    async iniciar_sesion() {
      let user_exist = false;

      user_exist = await this.verificar_urusario(user_exist);
      if (user_exist) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Iniciando Sesión",
          showConfirmButton: false,
          timer: 1500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          this.$store.state.show_navbar = true;
          // fondo_naranja();
          this.$store.state.user_auth = true;
          this.$router.replace("/novedades");
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Usuario y/o contraseña incorrectos...",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    async verificar_urusario(user_exist) {
      await db
        .collection("usuarios")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (
              doc.data().u_correo == this.email &&
              doc.data().u_contraseña == this.contraseña
            ) {
              user_exist = true;
              if (doc.data().u_registrado_por) {
                this.$store.state.email = doc.data().u_registrado_por;
                this.$store.state.id = `${doc.id}`;
                this.$store.state.email_session = doc.data().u_correo;
              } else {
                this.$store.state.email = doc.data().u_correo;
                this.$store.state.email_session = doc.data().u_correo;
                this.$store.state.id = doc.id,
                this.$store.state.session_nombre = doc.data().u_nombre_usuario;
                this.$store.state.session_apellido = doc.data().u_apellido;
              }

              // VARIABLES MSP
              this.session_email = this.email;
              this.$store.state.id = this.$store.state.id;
              // NIVELES DE USUARIO
              // ADMIN PRIV REGISTRO CLIENTE
              this.$store.state.global_esAdmin = doc.data().u_esAdmin;
              if (doc.data().u_privilegios_iper) {
                this.$store.state.global_privilegio_admin_registro_cliente.crear = doc.data().u_privilegios_iper.m_administracion.registro_cliente.crear;
                this.$store.state.global_privilegio_admin_registro_cliente.editar = doc.data().u_privilegios_iper.m_administracion.registro_cliente.editar;
                this.$store.state.global_privilegio_admin_registro_cliente.eliminar = doc.data().u_privilegios_iper.m_administracion.registro_cliente.eliminar;
                this.$store.state.global_privilegio_admin_registro_cliente.ver = doc.data().u_privilegios_iper.m_administracion.registro_cliente.ver;

                this.$store.state.global_privilegio_admin_registro_proceso.crear = doc.data().u_privilegios_iper.m_administracion.registro_proceso.crear;
                this.$store.state.global_privilegio_admin_registro_proceso.editar = doc.data().u_privilegios_iper.m_administracion.registro_proceso.editar;
                this.$store.state.global_privilegio_admin_registro_proceso.eliminar = doc.data().u_privilegios_iper.m_administracion.registro_proceso.eliminar;
                this.$store.state.global_privilegio_admin_registro_proceso.ver = doc.data().u_privilegios_iper.m_administracion.registro_proceso.ver;

                this.$store.state.global_privilegio_admin_registro_peligro.crear = doc.data().u_privilegios_iper.m_administracion.registro_peligro.crear;
                this.$store.state.global_privilegio_admin_registro_peligro.editar = doc.data().u_privilegios_iper.m_administracion.registro_peligro.editar;
                this.$store.state.global_privilegio_admin_registro_peligro.eliminar = doc.data().u_privilegios_iper.m_administracion.registro_peligro.eliminar;
                this.$store.state.global_privilegio_admin_registro_peligro.ver = doc.data().u_privilegios_iper.m_administracion.registro_peligro.ver;

                this.$store.state.global_privilegio_admin_registro_efecto_posible.crear = doc.data().u_privilegios_iper.m_administracion.registro_efectos.crear;
                this.$store.state.global_privilegio_admin_registro_efecto_posible.editar = doc.data().u_privilegios_iper.m_administracion.registro_efectos.editar;
                this.$store.state.global_privilegio_admin_registro_efecto_posible.eliminar = doc.data().u_privilegios_iper.m_administracion.registro_efectos.eliminar;
                this.$store.state.global_privilegio_admin_registro_efecto_posible.ver = doc.data().u_privilegios_iper.m_administracion.registro_efectos.ver;

                this.$store.state.global_privilegio_admin_registro_control_medida.crear = doc.data().u_privilegios_iper.m_administracion.registro_control_medida.crear;
                this.$store.state.global_privilegio_admin_registro_control_medida.editar = doc.data().u_privilegios_iper.m_administracion.registro_control_medida.editar;
                this.$store.state.global_privilegio_admin_registro_control_medida.eliminar = doc.data().u_privilegios_iper.m_administracion.registro_control_medida.eliminar;
                this.$store.state.global_privilegio_admin_registro_control_medida.ver = doc.data().u_privilegios_iper.m_administracion.registro_control_medida.ver;

                this.$store.state.global_privilegio_admin_registro_usuario.crear = doc.data().u_privilegios_iper.m_administracion.registro_usuario.crear;
                this.$store.state.global_privilegio_admin_registro_usuario.editar = doc.data().u_privilegios_iper.m_administracion.registro_usuario.editar;
                this.$store.state.global_privilegio_admin_registro_usuario.eliminar = doc.data().u_privilegios_iper.m_administracion.registro_usuario.eliminar;
                this.$store.state.global_privilegio_admin_registro_usuario.ver = doc.data().u_privilegios_iper.m_administracion.registro_usuario.ver;

                this.$store.state.global_privilegio_admin_registro_regional.crear = doc.data().u_privilegios_iper.m_administracion.registro_regionales.crear;
                this.$store.state.global_privilegio_admin_registro_regional.editar = doc.data().u_privilegios_iper.m_administracion.registro_regionales.editar;
                this.$store.state.global_privilegio_admin_registro_regional.eliminar = doc.data().u_privilegios_iper.m_administracion.registro_regionales.eliminar;
                this.$store.state.global_privilegio_admin_registro_regional.ver = doc.data().u_privilegios_iper.m_administracion.registro_regionales.ver;

                // MATRIZ PELIGRO PRIV
                this.$store.state.global_privilegio_matriz_peligro.ver = doc.data().u_privilegios_iper.m_matriz_peligro.ver;
                this.$store.state.global_privilegio_matriz_peligro.consultar = doc.data().u_privilegios_iper.m_matriz_peligro.consultar;
                this.$store.state.global_privilegio_matriz_peligro.crear = doc.data().u_privilegios_iper.m_matriz_peligro.crear;
                this.$store.state.global_privilegio_matriz_peligro.editar = doc.data().u_privilegios_iper.m_matriz_peligro.editar;
                this.$store.state.global_privilegio_matriz_peligro.eliminar = doc.data().u_privilegios_iper.m_matriz_peligro.eliminar;
                this.$store.state.global_privilegio_matriz_peligro.descargar_excel = doc.data().u_privilegios_iper.m_matriz_peligro.descargar_excel;
                this.$store.state.global_privilegio_matriz_peligro.copiar_matriz = doc.data().u_privilegios_iper.m_matriz_peligro.copiar_matriz;
                this.$store.state.global_privilegio_matriz_peligro.control_cambios = doc.data().u_privilegios_iper.m_matriz_peligro.control_cambios;
                this.$store.state.global_privilegio_matriz_peligro.verificacion_cyd = doc.data().u_privilegios_iper.m_matriz_peligro.verificacion_cyd;

                this.$store.state.global_privilegio_consulta.ver = doc.data().u_privilegios_iper.m_consulta.ver;
                this.$store.state.global_privilegio_consulta.excel = doc.data().u_privilegios_iper.m_consulta.excel;
                this.$store.state.global_privilegio_consulta.pdf = doc.data().u_privilegios_iper.m_consulta.pdf;

                const todas = doc.data().u_regionales_todas;
                if (todas) {
                  this.$store.state.global_privilegio_regionales_todas = true;
                } else {
                  this.obtener_privilegios_regionales(doc.id);
                }
              }
            }
          });
        });

      return user_exist;
    },

    async obtener_privilegios_regionales(id_usuario) {
      await db
        .collection(`usuarios/${id_usuario}/u_test_regional`)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.$store.state.global_privilegio_regional.push(doc.data());
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },

    versionCeluApto() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // CONVERTIR PANTALLA DE CELULAR
      if (
        /windows phone/i.test(userAgent) ||
        /android/i.test(userAgent) ||
        (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
      ) {
        this.movil_login = true;
      } else {
        this.pc_login = true;
      }
    },

    pausar_corousel() {
      $("#carouselMovil").carousel("pause");
    },

    consultarMatriz() {
      this.$router.replace("/qmatriz/" + this.url_mariz);
    },

    // ACTIVAR LECTOR
    activar_lector() {
      this.active = true;
      // DESACTIVAR LECTOR
      $("#query_matriz").on("hidden.bs.modal", (e) => {
        this.active = false;
      });
    },

    onDecode(_mid) {
      this.$router.replace("/qmatriz/" + _mid);
    },

    // INICIAR LECTOR QR Y DETECTAR ERRORES
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "Error: Debes otorgar permiso de acceso a la cámara";
        } else if (error.name === "NotFoundError") {
          this.error = "Error: No hay cámara en este dispositivo";
        } else if (error.name === "NotSupportedError") {
          this.error = "Error: Requieres de un sitio seguro (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "Error: ¿La cámara ya está en uso?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "Error: Las cámaras instaladas no son adecuadas";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "Error: Stream API no es compatible con este navegador";
        }
      }
    },
  },
};
</script>

<style scoped>
/* PONEMOS UN COLOR DE FONDO Y REDONDEAMOS LAS ESQUINAS DEL TRACK */
/* .container::-webkit-scrollbar-track {
  background: #e1e1e1;
  border-radius: 4px;
} */

/* CAMBIAMOS EL FONDO CUANDO ESTÉ EN ACTIVE O HOVER */
/* .container::-webkit-scrollbar-track:hover,
.container::-webkit-scrollbar-track:active {
  background: #d4d4d4;
} */

#mySidenav a {
  position: fixed;
  left: -178px;
  transition: 0.3s;
  padding: 15px;
  padding-left: 5px;
  width: 200px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  border-radius: 0px 64px 64px 0px !important;
  -moz-border-radius: 0px 64px 64px 0px !important;
  -webkit-border-radius: 0px 64px 64px 0px !important;
  border: 2px solid black;
  cursor: pointer;
}

#mySidenavMovil a {
  position: fixed;
  left: -165px;
  transition: 0.3s;
  padding: 15px;
  padding-left: 5px;
  width: 200px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  border-radius: 0px 64px 64px 0px !important;
  -moz-border-radius: 0px 64px 64px 0px !important;
  -webkit-border-radius: 0px 64px 64px 0px !important;
  cursor: pointer;
}

#mySidenav a:hover {
  left: 0;
}

#about {
  top: 30%;
  background-color: #4caf50;
}

#aboutMovil {
  top: 30%;
  background-color: #4caf50;
}
</style>